import { RiMailLine, RiMessage2Fill } from "@remixicon/react";
import React from "react";
import { ConversationSourceType, Maybe } from "../../../../__generated__/api";
import { ReactComponent as SlackIcon } from "../../../../assets/img/slack-logo.svg";
import { ReactComponent as MicrosoftTeamsIcon } from "../../../../assets/img/microsoft-teams.svg";

export const SOURCE_TO_ICON = {
    [ConversationSourceType.SlackChannel]: <SlackIcon />,
    [ConversationSourceType.MicrosoftTeams]: <MicrosoftTeamsIcon />,
    [ConversationSourceType.ConversationGroup]: <RiMessage2Fill />,
    [ConversationSourceType.Email]: <RiMailLine />,
};
export default function Source({ type, text }: {
    type?: Maybe<string>;
    text?: Maybe<string>;
}) {
    return (
        <span>
            {
                type && SOURCE_TO_ICON[type as ConversationSourceType]
            }
            {" "}
            {text}
        </span>
    );
}

Source.defaultProps = {
    type: undefined,
    text: undefined,
};
